import { render, staticRenderFns } from "./IconChartSquareBarSolid.vue?vue&type=template&id=5bdaf176"
import script from "./IconChartSquareBarSolid.vue?vue&type=script&lang=js"
export * from "./IconChartSquareBarSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports